import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { LightImageComponent } from './light-image.component';
import { LoadingComponentModule } from '../loading/loading.module';
import { MotePipesModule } from '../../pipes/mote-pipes.module';
import { SvgIconModule } from '../svg-icon/svg-icon.module';
import { OfflineModule } from '../../offline';

@NgModule({
    declarations: [LightImageComponent],
    imports: [
        CommonModule,
        LoadingComponentModule,
        MotePipesModule,
        OfflineModule,
        SvgIconModule
    ],
    exports: [LightImageComponent]
})
export class LightImageModule { }
